// Components
import { Flex, Text } from 'yard-utilities/components'

interface ReviewProps {
  name: React.ReactNode
  quote: string
  message: string
  memberSince: number
}

const TextReviewCard = ({ name, quote, message, memberSince }: ReviewProps) => {
  return (
    <Flex flexDirection="column" center style={{ marginInline: '-1rem' }}>
      <Text tagName="h3" variant="title-5" align="center" spacing={{ sm: 16 }}>
        {quote}
      </Text>
      <Text
        tagName="p"
        variant="body-1"
        align="center"
        textColor="grey-2"
        spacing={{ sm: 8 }}
      >
        {message}
      </Text>
      <Text tagName="p" variant="body-1" align="center" spacing={{ sm: 4 }}>
        {name}
      </Text>
      <Text tagName="p" variant="body-3" align="center" textColor="grey-2">
        Miembro desde {memberSince}
      </Text>
    </Flex>
  )
}

export default TextReviewCard
